import * as React from 'react'

const Vehicles = (props: { className: 'string' }) => {
  return (
    <svg className={'icon ' + props.className} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <g id='Canvas'>
        <g id='Drivers' clipPath='url(#clip0)'>
          <path
            d='M 12 0C 15.3057 0 18.1321 1.17357 20.4793 3.52072C 22.8264 5.86786 24 8.69429 24 12C 24 15.3057 22.8264 18.1321 20.4793 20.4793C 18.1321 22.8264 15.3057 24 12 24C 8.69429 24 5.86786 22.8264 3.52072 20.4793C 1.17357 18.1321 0 15.3057 0 12C 0 8.69429 1.17357 5.86786 3.52072 3.52072C 5.86786 1.17357 8.69429 0 12 0ZM 12 3.01008C 10.0918 3.01008 8.3673 3.56551 6.82643 4.67637C 5.28555 5.78723 4.19261 7.22956 3.54759 9.00336C 3.54759 9.00336 6 8 12 8C 18 8 20.4524 9.00336 20.4524 9.00336C 19.8074 7.22956 18.7144 5.78723 17.1736 4.67637C 15.6327 3.56551 13.9082 3.01008 12 3.01008ZM 3.01008 11.9866C 3.01008 14.2083 3.71781 16.1478 5.13326 17.8052C 6.54871 19.4625 8.33147 20.4703 10.4815 20.8287C 10.4457 18.374 10.9513 15.72 9.5 14C 8.04871 12.28 5.05263 11.9866 3.01008 11.9866ZM 13.5185 20.8287C 15.6685 20.4703 17.4513 19.4625 18.8667 17.8052C 20.2822 16.1478 20.9899 14.2083 20.9899 11.9866C 18.9474 11.9866 15.9513 12.28 14.5 14C 13.0487 15.72 13.5543 18.374 13.5185 20.8287Z'
            id='Vector'
          />
          <circle cx='2' cy='2' r='2' transform='translate(10 9)' fill='#fff' id='Ellipse' />
        </g>
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='24' height='24' fill='#fff' />
        </clipPath>
      </defs>
    </svg>
  )
}
export default Vehicles



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/Vehicles.tsx